import { DocumentTypeStateInterface } from '.';

function state(): DocumentTypeStateInterface {
  return {
    documentType: [],
  };
}

export default state;
